import { useAxios } from '../Plugins/axios';
import { useRoute } from '../Plugins/ziggy';
export default class CompanyUserService {
    axios;
    route;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
    }
    get(data) {
        return this.axios.get(this.route('admin.companies.show', data));
    }
    store(companyId, data) {
        return this.axios.post(this.route('admin.companies.users'), data);
    }
    update(companyId, userId, data) {
        return this.axios.patch(this.route('admin.companies.users.update', [companyId, userId]), data);
    }
}
